export const CSVLanguages = {
  FR: 'FR',
  EN: 'EN',
  ES: 'ES',
} as const;

export type CSVLanguage = (typeof CSVLanguages)[keyof typeof CSVLanguages];

export const employeeCSVLanguage = (column: string): CSVLanguage | null => {
  if (column === 'Prénom') {
    return CSVLanguages.FR;
  } else if (column === 'First name') {
    return CSVLanguages.EN;
  } else if (column === 'Nombre') {
    return CSVLanguages.ES;
  }
  return null;
};

const expectedEnglishFields = [
  'First name',
  'Last name',
  'Email address',
  'Job title',
  'Personal email address',
];

const expectedFrenchFields = [
  'Prénom',
  'Nom de famille',
  'Titre du poste',
  'Adresse courriel',
  'Adresse courriel personnelle',
];

const expectedSpanishFields = [
  'Nombre',
  'Apellido',
  'Correo electrónico',
  'Puesto de trabajo',
  'Correo electrónico personal',
];

export const employeeCSVColumnHeadersMap = {
  EN: expectedEnglishFields,
  FR: expectedFrenchFields,
  ES: expectedSpanishFields,
};

export const employeeLicenseTypeColumn = (
  isMultiPlanOrganization: boolean,
  language: string
): string | undefined => {
  const licenseTypes = {
    EN: 'License Type',
    FR: 'Type de licence',
    ES: 'Tipo de licencia',
  };
  if (isMultiPlanOrganization) {
    return licenseTypes[language as keyof typeof licenseTypes];
  }
};

export const employeeManagerColumn = (
  ithManagerField: boolean,
  language: string
): string | undefined => {
  const managerColumn = {
    EN: 'Manager',
    FR: 'Gestionnaire',
    ES: 'Gerente',
  };
  if (ithManagerField) {
    return managerColumn[language as keyof typeof managerColumn];
  }
};

export const generateEmployeeImportTemplateCSVData = (
  format: Record<string, string>,
  options: { isMultiPlanOrganization: boolean; ithManagerField: boolean }
): Array<Record<string, string>> => {
  return [
    {
      [format.firstName]: 'John',
      [format.lastName]: 'Doe',
      [format.email]: 'john.doe@example.com',
      [format.jobTitle]: 'Designer',
      ...(options.isMultiPlanOrganization
        ? { [format.licenseType]: 'Pro' }
        : {}),
      [format.personalEmail]: '',
      [format.groups]: '',
      ...(options.ithManagerField
        ? { [format.manager]: 'manager@example.com' }
        : {}),
    },
  ];
};

export const employeeCSVLanguageFormat = (
  language: CSVLanguage
): Record<string, string> | undefined => {
  const csvFormat = {
    FR: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'Adresse courriel',
      jobTitle: 'Titre du poste',
      licenseType: 'Type de licence',
      personalEmail: 'Adresse courriel personnelle',
      groups: 'Groupes',
      manager: 'Gestionnaire',
    },
    EN: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email address',
      jobTitle: 'Job title',
      licenseType: 'License Type',
      personalEmail: 'Personal email address',
      groups: 'Groups',
      manager: 'Manager',
    },
    ES: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      jobTitle: 'Puesto de trabajo',
      licenseType: 'Tipo de licencia',
      personalEmail: 'Correo electrónico personal',
      groups: 'Grupos',
      manager: 'Gerente',
    },
  };
  return csvFormat[language as keyof typeof csvFormat];
};
